import { type Context, createContext } from 'react';

import type { BaseInputProps } from '../base-input.types.js';

export type BaseInputContextProps = {
  /** Whether the element is in an error state. */
  hasError?: boolean;
  /** Whether the element is disabled. */
  disabled?: boolean;
  /** Whether the element is aria-disabled. */
  ariaDisabled?: boolean;
  /** The variant of the input. */
  variant?: BaseInputProps['variant'];
};

/**
 * This context keeps all information needed for the input base state.
 * @param hasError - defines if the element is in an error state; it's set to false by default
 * @param disabled - defines if the element is disabled; it's set to false by default
 * @param variant - defines if the element's variant, used for styling; it's set to emphasized by default
 */
export const BaseInputContext: Context<BaseInputContextProps> =
  createContext<BaseInputContextProps>({
    hasError: false,
    disabled: false,
    ariaDisabled: false,
    variant: 'default',
  });
